'use strict';

angular.module('app.advertiserCampaignList')

.directive('advertiserCampaignListDirective', function () {
        return {
            controller: 'advertiserCampaignListCtrl',
            templateUrl: 'app/sideBarMenu/advertiserCampaignList/advertiserCampaignList.html?app_v=deployDate',
            scope: {}
        };
})